import React from "react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import { PASSES_COLUMNS } from "../../../ComplianceSearch/constants";
import { Table } from "../../../../components/ui";
import usePagination from "../../../../hooks/usePagination";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { fundedComplianceProfileActions } from "../../../../reducers/fundedComplianceProfile";

const Passes: React.FC = () => {
  const dispatch = useDispatch();
  const params: { id: string } = useParams();
  const compliance_entries_id = +params.id;

  const { passers } = useSelector((state) => state.fundedComplianceProfile);

  const pagination = usePagination();

  useQuery({
    queryKey: [
      COMPLIANCE_API_URLS.getPasses,
      pagination.page,
      pagination.limit,
      compliance_entries_id,
    ],
    async queryFn({ signal }) {
      try {
        const query = new URLSearchParams();
        query.append("limit", pagination.limit.toString());
        query.append("page", pagination.page.toString());
        query.append("compliance_entries_id", compliance_entries_id.toString());

        dispatch(fundedComplianceProfileActions.fetchPassersRequest());
        const response = await ComplianceAPI.getWatchlistPassesRequest(query.toString(), signal);
        dispatch(fundedComplianceProfileActions.fetchPassersSuccess(response.data.results));
        pagination.setCount(response.data.results.count);
        return response;
      } catch (error) {
        console.error("Error fetching passes", error);
        dispatch(fundedComplianceProfileActions.fetchPassersFailed());
      }
    },
  });

  return (
    <Table
      columns={PASSES_COLUMNS}
      data={passers.data.rows}
      loading={passers.isLoading}
      pagination={pagination}
      extractKey={(row) => row.id}
      csv_table_name="Passes"
      theadTitle="Passes"
    />
  );
};

export default Passes;
